/**
 * Permissions, mirroring the server's list.
 *
 * Kept in its own module rather than beside the auth context so that both a
 * component and a plain module can import them without breaking fast refresh.
 *
 * These are used to decide what to *show*. The API checks the same permission
 * on every request, so hiding a control is a courtesy, not the boundary.
 */
export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard:view',

  USER_VIEW: 'user:view',
  USER_MANAGE: 'user:manage',
  USER_SUSPEND: 'user:suspend',

  STAY_PROPERTY_VIEW: 'stay_property:view',
  STAY_PROPERTY_MODERATE: 'stay_property:moderate',
  STAY_BOOKING_VIEW: 'stay_booking:view',
  STAY_BOOKING_MANAGE: 'stay_booking:manage',

  BROKER_VIEW: 'broker:view',
  BROKER_MODERATE: 'broker:moderate',
  BROKER_PROPERTY_VIEW: 'broker_property:view',
  BROKER_PROPERTY_MODERATE: 'broker_property:moderate',
  LEAD_VIEW: 'lead:view',
  DEAL_VIEW: 'deal:view',

  AGENT_VIEW: 'agent:view',
  AGENT_MANAGE: 'agent:manage',


  MODERATION_VIEW: 'moderation:view',
  MODERATION_ACT: 'moderation:act',

  FINANCE_VIEW: 'finance:view',
  FINANCE_MANAGE: 'finance:manage',
  PAYOUT_APPROVE: 'payout:approve',
  REFUND_ISSUE: 'refund:issue',
  CREDIT_ADJUST: 'credit:adjust',

  CONFIG_VIEW: 'config:view',
  NOTIFICATION_SEND: 'notification:send',
  CONFIG_MANAGE: 'config:manage',

  SUPPORT_VIEW: 'support:view',
  SUPPORT_RESPOND: 'support:respond',

  AUDIT_VIEW: 'audit:view',
  ADMIN_MANAGE: 'admin:manage',
};

export default PERMISSIONS;
